export default __webpack_public_path__ + "static/media/postThree.ca44f4d7.jpg";